<div class="p-0">
  <div class="jumbotron jumbotron--ie-fix d-flex align-items-center position-relative">
    <div class="container">
      <div *ngIf="user.employee; else nonEmployeeJumboText" class="col-lg-7 col-md-6 col-sm-10 mt-2">
        <h1 class="jumbotron-header">Free and Specially Priced Software</h1>
        <p class="jumbotron-text">The Office of Software Licensing offers free and discounted software for students,
          faculty and staff of the University of Utah.</p>
      </div>
      <ng-template #nonEmployeeJumboText>
        <div class="col-lg-7 col-md-6 col-sm-10 mt-2">
          <h1 class="jumbotron-header">Free and Specially Priced Student Software</h1>
          <p class="jumbotron-text">The Office of Software Licensing provides a variety of educational software products
            for students.</p>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="skirt d-flex align-items-center">
    <div class="container">
      <div *ngIf="user.employee; else nonEmployeeJumboSkirtText" class="col-lg-7 col-md-10 mt-5">
        <h2 class="jumbotron-header-jr">Free For Official Use</h2>
        <p class="jumbotron-text">Special arrangements make industry-standard software available for use by university
          students, faculty and staff.</p>
      </div>
      <ng-template #nonEmployeeJumboSkirtText>
        <div class="col-lg-7 col-md-10 mt-5">
          <h2 class="jumbotron-header-jr">Free For Academic Use</h2>
          <p class="jumbotron-text">Students fees allow the university to give students access to industry-standard
            software products as part of their enrollment.</p>
        </div>
      </ng-template>

      <div class="row d-flex justify-content-center col-md-12 my-5">
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="adobeImage"
                             [link]="adobeLink"
                             [buttonText]="adobeButtonText"></app-free-offering>
        </div>
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="microsoftImage"
                             [link]="microsoftLink"
                             [buttonText]="microsoftButtonText"></app-free-offering>
        </div>
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="zoomImage"
                             [link]="zoomLink"
                             [buttonText]="zoomButtonText"></app-free-offering>
        </div>
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="matlabImage"
                             [link]="matlabLink"
                             [buttonText]="matlabButtonText"></app-free-offering>
        </div>
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="docusignImage"
                             [link]="docusignLink"
                             [buttonText]="docusignButtonText"></app-free-offering>
        </div>
        <div class="d-lg-none col-md-10 col-sm-12 text-center mt-5">
          <app-free-offering [image]="qualtricsImage"
                             [link]="qualtricsLink"
                             [buttonText]="qualtricsButtonText"></app-free-offering>
        </div>
      </div>


      <div class="row d-flex justify-content-center col-lg-12 mt-4">
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-4" src="../../../../assets/images/{{adobeImage}}">
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-4" src="../../../../assets/images/{{microsoftImage}}">
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-4" src="../../../../assets/images/{{zoomImage}}">
        </div>
      </div>

      <div class="row d-flex justify-content-center col-lg-12 mt-1 mb-5">
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="adobeLink"
                                    [internalLink]="true"
                                    [buttonText]="adobeButtonText"></app-free-offering-button>
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="microsoftLink"
                                    [buttonText]="microsoftButtonText"></app-free-offering-button>
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="zoomLink"
                                    [buttonText]="zoomButtonText"></app-free-offering-button>
        </div>
      </div>


      <div class="row d-flex justify-content-center col-lg-12 mt-5 pt-5">
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-1 pt-2" width="180px" src="../../../../assets/images/{{matlabImage}}">
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-1 pt-2" width="180px" src="../../../../assets/images/{{docusignImage}}">
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <img class="pb-3" width="160px" src="../../../../assets/images/{{qualtricsImage}}">
        </div>
      </div>

      <div class="row d-flex justify-content-center col-lg-12 mt-1 mb-5 pb-5">
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="matlabLink"
                                    [buttonText]="matlabButtonText"></app-free-offering-button>
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="docusignLink"
                                    [buttonText]="docusignButtonText"></app-free-offering-button>
        </div>
        <div class="d-none d-lg-block col-lg-4 text-center px-4">
          <app-free-offering-button [link]="qualtricsLink"
                                    [buttonText]="qualtricsButtonText"></app-free-offering-button>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="isEligibleForDownloadFiles" class="hem d-flex align-items-center">
    <div class="container">
      <div class="col-lg-7 col-md-10 mt-5">
        <h2 class="jumbotron-header-jr">Need Installation Files for Your License?</h2>
        <p class="jumbotron-text">If you or your organization have already purchased a software license, find and download the installation files here.</p>
      </div>
      <div class="row d-flex col-lg-12 my-5 justify-content-center justify-content-lg-start">
        <div class="d-lg-block col-lg-4 col-md-10 col-12 text-center px-4 mb-4">
          <app-free-offering-button link="/download-files"
                                    buttonText="Installation Files"></app-free-offering-button>
        </div>
      </div>
    </div>
  </div>
</div>
